const AUTH_TOKEN = "token";
const SYSTEM = "system";
import { saveAs } from 'file-saver';

export default {
    getAuthToken() {
        if (localStorage.getItem(AUTH_TOKEN) === null || localStorage.getItem(AUTH_TOKEN) === 'null' || localStorage.getItem(AUTH_TOKEN) === "") {
            return null;
        }

        return localStorage.getItem(AUTH_TOKEN);
    },
    setAuthToken(token) {
        localStorage.setItem(AUTH_TOKEN, token);
    },
    getSystem() {
        if (localStorage.getItem(SYSTEM) == null || localStorage.getItem(SYSTEM) == 'null' || localStorage.getItem(SYSTEM) === '') {
            return {};
        }

        return JSON.parse(localStorage.getItem(SYSTEM));
    },
    setSystem(system) {
        localStorage.setItem(SYSTEM, JSON.stringify(system));
    },

    pdfDownFile(url, name) {
        let oReq = new XMLHttpRequest();
        let URLToPDF = url;
        oReq.open("GET", URLToPDF, true);
        oReq.responseType = "blob";
        oReq.onload = function() {
            let file = new Blob([oReq.response], { 
                type: 'application/pdf' 
            });
            saveAs(file, name);
        };
        oReq.send();
    },
    hrefDownFile(url,type) {
        let xhr = new XMLHttpRequest();
        xhr.open("get", url, true); // get、post都可
        xhr.responseType = "blob";  // 转换流
        xhr.setRequestHeader("Auth-Token", this.getAuthToken()); // token键值对
        xhr.onload = function() {
            if (this.status == 200) {
                console.error(this.response)
                let blob = this.response;
                let a = document.createElement("a")
                let url = window.URL.createObjectURL(blob)
                a.href = url
              if(type){

                a.download = `下载文件.${type}`// 文件名
              }else{
                a.download = "下载文件.xls"// 文件名
              }
                a.click()
            }
            window.URL.revokeObjectURL(url)
        }
        xhr.send();
    },
    hrefDownExcel(url,type) {
        let xhr = new XMLHttpRequest();
        xhr.open("get", url, true); // get、post都可
        xhr.responseType = "blob";  // 转换流
        xhr.setRequestHeader("X-Auth-Token", this.getAuthToken()); // token键值对
        xhr.onload = function() {
            if (this.status == 200) {
                console.error(this.response)
                let blob = this.response;
                let a = document.createElement("a")
                let url = window.URL.createObjectURL(blob)
                a.href = url
              if(type){

                a.download = `下载文件.${type}`// 文件名
              }else{
                a.download = "下载文件.xls"// 文件名
              }
                a.click()
            }
            window.URL.revokeObjectURL(url)
        }
        xhr.send();
    },

    jsonDownFile(url) {
        let xhr = new XMLHttpRequest();
        xhr.open("get", url, true); // get、post都可
        xhr.responseType = "blob";  // 转换流
        xhr.setRequestHeader("Auth-Token", this.getAuthToken()); // token键值对
        xhr.onload = function() {
            if (this.status == 200) {
                console.error(this.response)
                let blob = this.response;
                let a = document.createElement("a")
                let url = window.URL.createObjectURL(blob)
                a.href = url
                a.download = "导出文件.json"  // 文件名
                a.click()   
            }
            window.URL.revokeObjectURL(url)
        }
        xhr.send();
    },

    jsonDownPdf(url) {
        let xhr = new XMLHttpRequest();
        xhr.open("get", url, true); // get、post都可
        xhr.responseType = "blob";  // 转换流
        xhr.setRequestHeader("Auth-Token", this.getAuthToken()); // token键值对
        xhr.onload = function() {
            if (this.status == 200) {
                console.error(this.response)
                let blob = this.response;
                let a = document.createElement("a")
                let url = window.URL.createObjectURL(blob)
                a.href = url
                a.download = "导出文件.pdf"  // 文件名
                a.click()   
            }
            window.URL.revokeObjectURL(url)
        }
        xhr.send();
    },
    zipDownFile(url) {
        let xhr = new XMLHttpRequest();
        xhr.open("get", url, true); // get、post都可
        xhr.responseType = "blob";  // 转换流
        xhr.setRequestHeader("Auth-Token", this.getAuthToken()); // token键值对
        xhr.onload = function() {
            if (this.status == 200) {
                console.error(this.response)
                let blob = this.response;
                let a = document.createElement("a")
                let url = window.URL.createObjectURL(blob)
                a.href = url
                a.download = "导出文件.zip"  // 文件名
                a.click()
            }
            window.URL.revokeObjectURL(url)
        }
        xhr.send();
    },
   
    imagDownFile(url,type) {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';//设置响应类型为二进制流
        xhr.setRequestHeader("Auth-Token", this.getAuthToken()); // token键值对
        xhr.onload = function () {
          if (this.status === 200) {
            let blob = new Blob([this.response], { type: 'image/png' });// 将二进制流数据转化为Blob类型
            let a = document.createElement('a');
            let link = window.URL.createObjectURL(blob);// 创建一个URL对象
            a.href = link;// 设置下载链接
            a.download = `下载文件.${type}`;// 设置下载文件名
            a.click();// 模拟点击事件，触发下载
            window.URL.revokeObjectURL(link);// 释放URL对象
          }
        };
        xhr.send();
      },
      
    docxDownlod(url,type) {
        let xhr = new XMLHttpRequest();
        xhr.open("get", url, true); // get、post都可
        xhr.responseType = "blob";  // 转换流
        xhr.setRequestHeader("Auth-Token", this.getAuthToken()); // token键值对
        xhr.onload = function() {
            if (this.status == 200) {
                console.error(this.response)
                let blob = this.response;
                let a = document.createElement("a")
                let url = window.URL.createObjectURL(blob)
                a.href = url
                a.download = `下载文件.${type}`  // 文件名
                a.click()   
            }
            window.URL.revokeObjectURL(url)
        }
        xhr.send();
    },

};
